import { ComponentLocatorMap } from '../types/ComponentLocatorMap';

export const loanDocumentListComponent = {
  getDocumentItem: (index: number) =>
    `loan-document-list.document-item-${index + 1}`,
  root: 'loan-document-list.root',
} as const satisfies ComponentLocatorMap;
